interface ITransactionPreSaleStatus {
  status: string;
  color: string;
  value: string;
}

export enum PROJECT_WORK_PROGRESS_ENUM {
  IN_PLANS = 'in_plans',
  IN_CONSTRUCTION = 'in_construction',
  FINALIZED = 'finalized',
}

export enum TRANSACTION_PRE_SALE_ENUM {
  ACTIVE = 'active',
  EXTERNAL = 'external',
}

export const PROJECT_WORK_PROGRESS = [
  {
    value: PROJECT_WORK_PROGRESS_ENUM.IN_PLANS,
    display_value: 'Preventa',
  },
  {
    value: PROJECT_WORK_PROGRESS_ENUM.IN_CONSTRUCTION,
    display_value: 'Construcción',
  },
  {
    value: PROJECT_WORK_PROGRESS_ENUM.FINALIZED,
    display_value: 'Terminado',
  },
];

export const TRANSACTION_PRE_SALE_STATUS: ITransactionPreSaleStatus[] = [
  {
    status: TRANSACTION_PRE_SALE_ENUM.ACTIVE,
    color: 'success',
    value: 'Activo',
  },
  {
    status: TRANSACTION_PRE_SALE_ENUM.EXTERNAL,
    color: 'danger',
    value: 'Vendido externo',
  },
];

export enum ProjectLayoutView {
  TOWER = 'tower',
  NEW_TOWER = 'new_tower',
  SUMMARIZE = 'summarize',
  DEFAULT = 'default',
  DETAILED = 'detailed',
  DETAILED_PRICELESS = 'detailed_priceless',
}

export type SearchType = 'places' | 'characteristics';

export enum PROJECT_WORK_PHASE_ENUM {
  DESIGN_PERMISSIONS = 'design_permissions',
  PRE_SALE_ACTIVE = 'pre_sale_active',
  CONSTRUCTION_START = 'construction_start',
  UNITS_DELIVERY = 'units_delivery',
}

export const PROJECT_WORK_PHASE_LABELS: Record<string, string> = {
  [PROJECT_WORK_PHASE_ENUM.DESIGN_PERMISSIONS]: 'Permisos de diseño',
  [PROJECT_WORK_PHASE_ENUM.PRE_SALE_ACTIVE]: 'Pre-venta activa',
  [PROJECT_WORK_PHASE_ENUM.CONSTRUCTION_START]: 'Inicio de construcción',
  [PROJECT_WORK_PHASE_ENUM.UNITS_DELIVERY]: 'Entrega de unidades',
};

export const PROJECT_WORK_PHASE_TO_PROGRESS: Record<string, string> = {
  [PROJECT_WORK_PHASE_ENUM.DESIGN_PERMISSIONS]:
    PROJECT_WORK_PROGRESS_ENUM.IN_PLANS,
  [PROJECT_WORK_PHASE_ENUM.PRE_SALE_ACTIVE]:
    PROJECT_WORK_PROGRESS_ENUM.IN_PLANS,
  [PROJECT_WORK_PHASE_ENUM.CONSTRUCTION_START]:
    PROJECT_WORK_PROGRESS_ENUM.IN_CONSTRUCTION,
  [PROJECT_WORK_PHASE_ENUM.UNITS_DELIVERY]:
    PROJECT_WORK_PROGRESS_ENUM.FINALIZED,
};

export const PROJECT_WORK_PHASE_ORDER = [
  PROJECT_WORK_PHASE_ENUM.DESIGN_PERMISSIONS,
  PROJECT_WORK_PHASE_ENUM.PRE_SALE_ACTIVE,
  PROJECT_WORK_PHASE_ENUM.CONSTRUCTION_START,
  PROJECT_WORK_PHASE_ENUM.UNITS_DELIVERY,
];
